module.exports = __webpack_public_path__ + "static/img/solution_img4.07d0c2d7.png";